<template>
  <div>
    <!--    <camera-chart v-if="indexStyle==1"></camera-chart>-->
    <!--    <div style="width: 100%;text-align: right;margin-top: 20px">-->
    <!--      <a-radio-group v-model="indexStyle">-->
    <!--        <a-radio :value="1">校园情绪趋势</a-radio>-->
    <!--        <a-radio :value="2">设备统计</a-radio>-->
    <!--      </a-radio-group>-->
    <!--    </div>-->

    <a-row
      style="
        height: calc(100% - 80px);
        width: calc(100% - 220px);
        background: white;
        position: absolute;
      "
    >
      <router-link :to="{ path: '/school/statistic/ArchiveSynthesizer' }">
        <a-col :span="8" style="height: 100%">
          <div
            style="
              padding-top: 150px;
              height: 500px;
              position: relative;
              top: calc(50% - 250px);
              width: calc(100% - 75px);
              left: 50px;
              background: #1783e8;
              border-radius: 16px;
              text-align: center;
              line-height: 100px;
              font-size: 36px;
              color: white;
              font-weight: bold;
            "
          >
            <div><img src="@assets/school/icon1.png" /></div>
            <div>筛查</div>
          </div>
        </a-col>
      </router-link>

      <router-link :to="{ path: '/school/statistic/ArchiveSynthesizer' }">
        <a-col :span="8" style="height: 100%">
          <div
            style="
              padding-top: 150px;
              height: 500px;
              position: relative;
              top: calc(50% - 250px);
              width: calc(100% - 50px);
              left: 25px;
              background: #ffbd59;
              border-radius: 16px;
              text-align: center;
              line-height: 100px;
              font-size: 36px;
              color: white;
              font-weight: bold;
            "
          >
            <div><img src="@assets/school/icon2.png" /></div>
            <div>评估</div>
          </div>
        </a-col>
      </router-link>

      <router-link :to="{ path: '/school/statistic/StudentMoodTrend' }">
        <a-col :span="8" style="height: 100%">
          <div
            style="
              padding-top: 150px;
              height: 500px;
              position: relative;
              top: calc(50% - 250px);
              width: calc(100% - 75px);
              left: 25px;
              background: #13b999;
              border-radius: 16px;
              text-align: center;
              line-height: 100px;
              font-size: 36px;
              color: white;
              font-weight: bold;
            "
          >
            <div><img src="@assets/school/icon3.png" /></div>
            <div>干预</div>
          </div>
        </a-col>
      </router-link>
    </a-row>
  </div>
</template>

<script>
import CameraChart from './CameraChart'

export default {
  name: 'Analysis',
  components: {
    CameraChart,
  },
  data() {
    return {
      indexStyle: 1,
    }
  },
  created() {},
  methods: {},
}
</script>
